module.exports = __webpack_public_path__ + "images/active-r.5ee5eddce6fc1b4c96cf938d549eec92.png";